import { render, staticRenderFns } from "./EsMatch.vue?vue&type=template&id=c52621f8&scoped=true&"
import script from "./EsMatch.vue?vue&type=script&lang=js&"
export * from "./EsMatch.vue?vue&type=script&lang=js&"
import style0 from "./EsMatch.vue?vue&type=style&index=0&id=c52621f8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52621f8",
  null
  
)

export default component.exports